import { Button, Text, ExternalLink, Flex } from 'roo-ui/components';
import { CUSTOMER_SUPPORT_HOTLINE_AU, CONTACT_US_URL } from 'config/constants';
import TelLink from 'components/TelLink';

const HelpText = ({ children, 'data-testid': dataTestId }) => (
  <Text color="greys.steel" as="div" textAlign="center" data-testid={dataTestId}>
    {children}
  </Text>
);

const CallToChange = () => (
  <Flex flexDirection="column" width={['100%', 'auto']}>
    <Button disabled block mb={3}>
      Call Us To Change
    </Button>
    <HelpText data-testid="call-to-cancel-hotline-message">
      Please call us on <TelLink number={CUSTOMER_SUPPORT_HOTLINE_AU} color="greys.steel" underline />
    </HelpText>
    <HelpText data-testid="call-to-cancel-other-options">
      Or view other{' '}
      <ExternalLink href={CONTACT_US_URL} underline>
        contact methods
      </ExternalLink>
    </HelpText>
  </Flex>
);

export default CallToChange;
